import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography, Button, Card, CardHeader, CardContent, CardActions, Grid, Link } from '@material-ui/core';
import { CheckCircleOutlineOutlined } from '@material-ui/icons';
import { genfunction } from '../../../helpers'
import theme from '../../../theme'
import DataAccess from '../../../api/constants';
import Moment from 'moment';
import { actionResetBookingTypes } from 'actions';
import { useDispatch, useSelector } from 'react-redux';

const { CustomMessageforconfirmpage, BookingTypeBarcodeHeader, PaymentCompleteTitle, ConfirmationReceiptMessage,
    DisableMemberPassBarcode, RedirectWaiverSigner, WaiverSignMessage, ShowReadableBarcode } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    center: {
        position: "relative",
        margin: "auto",
        maxWidth: "400px"
    },
    diplaynone: {
        display: "none"
    },
    textaligncenter: {
        textAlign: "center"
    },
    headerbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        textAlign: "left"
    },
    footerbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        textAlign: "left",
        padding: "16px"
    },
    headertext: {
        marginTop: "8px",
        marginRight: "10px"
    },
    image: {
        border: "5px solid white"
    }

}));

const PaymentCompletebox = props => {
    const { isshow, transaction } = props;
    const classes = useStyles();
    const dispatch = useDispatch();

    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const ALLGATickets = useSelector(state => state.reducerGaTicket.GATickets);

    const onClickHandler = () => {
        actionResetBookingTypes(dispatch);
        props.onClickHandler()
    }

    const VisibleStartAndEndTime = (tourEvent) => {

        let time = "";

        const bookType = bookingTypes.filter(x => x.BookingTypeID == tourEvent.BookingTypeID)[0];

        if (bookType) {
            if (bookType.ShowStartTime && bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormat(tourEvent.EventStartDateTime) + ' - ' + Moment(tourEvent.EventEndDateTime).format('hh:mm a');
            }

            if (bookType.ShowStartTime && !bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormat(tourEvent.EventStartDateTime);
            }

            if (!bookType.ShowStartTime && bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormat(tourEvent.EventEndDateTime);
            }

            if (!bookType.ShowStartTime && !bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormatwithoutTime(tourEvent.EventStartDateTime);
            }
        }

        return time;
    }

    const ShowWebDisplayName = (tourEvent) => {
        const bookType = bookingTypes.filter(x => x.BookingTypeID == tourEvent.BookingTypeID)[0];
        return bookType ? tourEvent.EventName : '';
    }

    const ShowTicketDisplayName = (ticket) => {
      const t = ALLGATickets.find(x => x.ProductID === ticket.ProductID);
      return t && t.WebProductName ? t.WebProductName : t.ProductName;
    }

    const ShowWaiverLinks = (tourEvent) => {
        const bookType = bookingTypes.find(x => x.BookingTypeID == tourEvent.BookingTypeID);
        return bookType && bookType.WaiverRequired;
    }

    const getEvent = (toureventid) => {
        if (toureventid)
            return transaction.Events.find(x => x.TourEventID == toureventid)
    }

    const getGATickets = () => {
        const tickets = transaction.Products.filter(ticket => ticket.GATickets && ticket.GATickets.length > 0);
        return tickets;
    }

    const GetGiftCards = () => {
        let giftcards = transaction.Products.filter(x => x.Giftcards && x.Giftcards.length > 0);
        return giftcards;
    }
    const groupbyTourEvent = () => {
        let products = [];
        transaction.Products.map(item => {
            let itemobj = products.find(x => x.TourEventID == item.TourEventID);
            if (itemobj == null || itemobj == undefined) {
                if (item.TourEventID !== undefined) {
                    products.push(item);
                }
            }
        })
        return products;
    }

    const GetMembershipPackage = () => {

        let membershippackage = [];
        let memPack = {
            packagename: transaction.MembershipPackages[0] && transaction.MembershipPackages[0].hasOwnProperty("PackageName") ? transaction.MembershipPackages[0].PackageName : "",
            expiry: '',
            primaryMemberNo: 0
        };

        if (transaction.Products && transaction.Products.length > 0) {
            transaction.Products.map(item => {
                if (item.hasOwnProperty("MemberCustomerID") && item.hasOwnProperty("MembershipPackageID")) {
                    if (item.MemberCustomerID === transaction.CustomerID) {

                        memPack.expiry = item.MembershipExpiryDate;
                        memPack.primaryMemberNo = item.MemberNo;

                        if (membershippackage.length == 0) {
                            membershippackage.push(memPack);
                        }
                    }
                }
            });
        }

        return membershippackage;
    }

    const getProductOptions = (product) => {
        if (product.Options) {

            let productWithOptions = product.Options.filter(x => x.Products && x.Products.length > 0 && x.Products.find(y => y.IsSelected == true) != undefined);
            if (productWithOptions && productWithOptions.length > 0) {
                return (
                    productWithOptions.map(option => {
                        return (
                            option.Products.map(opproduct => {
                                return (
                                    opproduct.IsSelected ?
                                        <Typography variant='subtitle2'>
                                            {genfunction.replaceEscapeCharacters(opproduct.ProductName)}
                                        </Typography> : ""
                                )
                            }))
                    })
                );
            }
        }

        return "";
    }

    const hasAnyBarcodesToShow = () => {
        let hasBarcodes = false;
        if (getGATickets().length > 0 || groupbyTourEvent().length > 0 || GetMembershipPackage().length > 0 || GetGiftCards().length > 0) {
            hasBarcodes = true;
        }
        return hasBarcodes;
    }

    if (transaction.hasOwnProperty('Products') == false)
        return ("");
    else {

        let amounts = genfunction.GetTotalAmount(transaction.Products)

        return (
            <div id="vt_component_checkout_complete_confirmation" className={classes.center + " " + (!isshow ? classes.diplaynone : "")}>
                <div className={classes.textaligncenter}>
                    <CheckCircleOutlineOutlined style={{ fontSize: 80, fontWeight: "lighter", color: theme.palette.success.main }}></CheckCircleOutlineOutlined>
                    <Typography display="block" color="primary" gutterBottom={true} variant="h4" component="h4">{PaymentCompleteTitle}</Typography>
                    <Typography display="block" gutterBottom={true} variant="h4" component="h4" style={{ marginBottom: "30px" }}>Thank you {transaction.Customer.FirstName + " " + transaction.Customer.LastName}!</Typography>
                    <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{ConfirmationReceiptMessage}</Typography>
                    <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{transaction.Customer.CustomerAddress[0].Email}</Typography>
                    {transaction.TabID ?
                        <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{"Order #: " + transaction.TabID + " | " + "Location : " + transaction.TabLocationName}</Typography>
                        : ""}
                    <Card style={{ borderRadius: "0px" }} >
                        <CardHeader className={classes.headerbox}
                            action={<Typography variant="h5" className={classes.headertext} color="inherit" component="h5">Receipt # {transaction.ReceiptNo}</Typography>}
                            title={"Transaction Summary"}
                            titleTypographyProps={{ color: "inherit" }}
                        />
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {transaction.OrderProducts.map(product => {
                                        return (
                                            <Grid key={product.ProductName + "_Food_ShopCart"} container item xs={12}>
                                                <Grid item xs={6} className={classes.productText} align="left">
                                                    <Typography variant='h6'>
                                                        {product.Quantity}x{genfunction.replaceEscapeCharacters(product.ProductName)}
                                                    </Typography>
                                                    {getProductOptions(product)}
                                                </Grid>
                                                <Grid item xs={6} className={classes.productText} align="right">
                                                    <Typography variant='h6'>
                                                        {genfunction.ccyFormat(genfunction.getOrderProductsTotalPrice([product]).subtotal)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                                <Grid item xs={6} style={{ textAlign: "left" }}>
                                    <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Total Sales</Typography>
                                    <Typography variant="h5" color="inherit" component="h5">Total Tax</Typography>
                                </Grid>
                                <Grid item xs={6} style={{ textAlign: "right" }} >
                                    <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">{genfunction.ccyFormat(amounts.totalExclTax)}</Typography>
                                    <Typography variant="h5" color="inherit" component="h5">{genfunction.ccyFormat(amounts.totalTax)}</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions disableSpacing className={classes.footerbox}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="h5" color="inherit" component="h5">Total Paid</Typography>
                                </Grid>
                                <Grid item xs={6} style={{ textAlign: "right" }} >
                                    <Typography variant="h5" color="inherit" component="h5">{genfunction.ccyFormat(amounts.totalInclTax)}</Typography>
                                </Grid>
                            </Grid>
                        </CardActions>
                    </Card>
                    {hasAnyBarcodesToShow() ?
                        <Card style={{ marginTop: "50px", borderRadius: "0px" }}>
                            <CardHeader className={classes.headerbox}
                                title={BookingTypeBarcodeHeader}
                                titleTypographyProps={{ color: "inherit" }}
                            />
                            <CardContent style={{ textAlign: "center" }}>
                                {
                                    getGATickets().length > 0 ? getGATickets().map(ticket => (
                                        ticket.GATickets.map(gaticket => (
                                            <div>
                                                <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{ShowTicketDisplayName(ticket)}</Typography>
                                                <img className={classes.image} alt="Logo" src={DataAccess.apiUrl + 'Barcode/?barcode=' + gaticket.Barcode + "&includeLable=" + ShowReadableBarcode} />
                                            </div>
                                        ))
                                    )) : null
                                }
                                {
                                    groupbyTourEvent().length > 0 ? groupbyTourEvent().map(item => (

                                        <div>

                                            <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{ShowWebDisplayName(getEvent(item.TourEventID))}</Typography>
                                            <Typography display="block" gutterBottom={true} variant="subtitle2" component="p">{VisibleStartAndEndTime(getEvent(item.TourEventID))}</Typography>
                                            {ShowWaiverLinks(getEvent(item.TourEventID)) ?
                                                <Link href={RedirectWaiverSigner + item.BookingID + "/" + transaction.Customer.LastName + "/" + transaction.Customer.CustomerAddress[0].Email} target="_blank" variant="subtitle2" >{WaiverSignMessage}</Link>
                                                : ""}
                                            <img className={classes.image} alt="Logo" src={DataAccess.apiUrl + 'Barcode/?barcode=\\' + item.BookingID + "&includeLable=" + ShowReadableBarcode} />
                                        </div>
                                    ))
                                        : null
                                }

                                {
                                    GetMembershipPackage().length > 0 && GetMembershipPackage().map(item => (
                                        <div>
                                            <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{item.packagename}</Typography>
                                            <Typography display="block" gutterBottom={true} variant="subtitle2" component="p">{'Expire : ' + genfunction.GetEventDateReceiptFormatwithoutTime(item.expiry)}</Typography>
                                            {!DisableMemberPassBarcode ?
                                                <img className={classes.image} alt="Logo" src={DataAccess.apiUrl + 'Barcode/?barcode=' + item.primaryMemberNo + "&includeLable=" + ShowReadableBarcode} /> : null}
                                        </div>
                                    ))
                                }
                                {
                                    GetGiftCards().length > 0 ? GetGiftCards().map(giftcard => (
                                        giftcard.Giftcards.map(gc => (
                                            <div>
                                                <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{giftcard.ProductName}</Typography>
                                                <Typography display="block" gutterBottom={true} variant="subtitle1" component="p"></Typography>
                                                <img className={classes.image} alt="Logo" src={DataAccess.apiUrl + 'Barcode/?barcode=' + gc.GiftcardNo + "&includeLable=" + ShowReadableBarcode} />
                                            </div>
                                        ))
                                    )) : null
                                }
                            </CardContent>
                        </Card>
                        : ""}
                    <Typography display="block" gutterBottom={true} style={{ marginTop: "30px" }} variant="subtitle1" component="p">{CustomMessageforconfirmpage}</Typography>
                    <Button style={{ marginTop: 10 }} variant="contained" color="primary" onClick={onClickHandler}>
                        OK
                    </Button>
                </div>
            </div >

        );
    }
};

PaymentCompletebox.propTypes = {
    isshow: PropTypes.bool.isRequired,
    transaction: PropTypes.object.isRequired
};

export default PaymentCompletebox;
